/* S-01 sign-in: one narrow column on the page surface. */
.page {
  display: grid;
  gap: var(--dimension-space-4);
  max-width: 440px;
  margin: 0 auto;
  padding: var(--dimension-space-12) var(--gutter) var(--dimension-space-8);
}
.step {
  display: grid;
  gap: var(--dimension-space-4);
  margin-top: var(--dimension-space-4);
}
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.strong {
  color: var(--color-text-primary);
}
.field {
  display: block;
}
.input {
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 0 var(--dimension-space-3);
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
}
.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--color-text-primary);
  text-decoration: underline;
  cursor: pointer;
}
:where(.link) {
  font: inherit;
}
.error {
  margin: 0;
  color: var(--color-status-danger);
}
